<template>
    <div>
        <div class="coverdetailsbloc">
            <span class="sub-title-header">{{$t('Cover.ShowCover.PRICE_DETAILS_SUB_TITLE')}}</span>
        </div>
        <div class="pricedetailsbloc">
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.insurancePremiumAmount">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.INSURANCE_PREMIUM_FIELD_NAME')}} : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.insurancePremiumAmount}} {{ cover.invoice.currency }}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.insuranceTaxAmount">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.INSURANCE_PREMIUM_TAX_FIELD_NAME')}} ({{cover.price.insuranceTaxRate}}) : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.insuranceTaxAmount}}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.serviceFeeAmount">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.SERVICE_FEES_AMOUNT_FIELD_NAME')}} ({{cover.price.serviceFeeRate}}): </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.serviceFeeAmount}}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.serviceFeeVatAmount">
               <v-flex xs6>
                  <v-label>{{$t('Cover.ShowCover.SERVICE_FEES_VAT_AMOUNT_FIELD_NAME')}} ({{cover.price.serviceFeeVatRate}}) : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.serviceFeeVatAmount}}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.totalServiceFee">
               <v-flex xs6>
                  <v-label ><span class="sub-title-header">{{$t('Cover.ShowCover.TOTAL_SERVICE_FEES_FIELD_NAME')}} : </span></v-label>
               </v-flex>
               <v-flex xs6 class="sub-title-header">
                   {{cover.price.totalServiceFee}}
               </v-flex>
            </v-layout>
        </div>
        <div class="pricedetailsfeesSession" v-if="!!cover.price.totalCollectionFee">
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.collectionFeeAmount">
               <v-flex xs6>
                  <v-label >{{$t('Cover.ShowCover.COLLECTION_FEES_AMOUNT_FIELD_NAME')}} ({{cover.price.collectionFeeRate}}) :</v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.collectionFeeAmount}}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.collectionFeeVatAmount">
               <v-flex xs6>
                  <v-label >{{$t('Cover.ShowCover.COLLECTION_FEES_VAT_AMOUNT_FIELD_NAME')}} ({{cover.price.collectionFeeVatRate}}) : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.collectionFeeVatAmount}}
               </v-flex>
            </v-layout>
             <v-layout row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label ><span class="sub-title-header">{{$t('Cover.ShowCover.TOTAL_COLLECTION_FEES_FIELD_NAME')}} : </span></v-label>
               </v-flex>
               <v-flex xs6 class="sub-title-header">
                   {{cover.price.totalCollectionFee}}
               </v-flex>
            </v-layout>
        </div>
        <div class="pricedetailsfeesSession" v-if="!!cover.price.totalTechnicalFee">
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.technicalFeeAmount">
               <v-flex xs6>
                  <v-label >{{$t('Cover.ShowCover.TECHNICAL_FEES_AMOUNT_FIELD_NAME')}} ({{cover.price.technicalFeeRate}}) :</v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.technicalFeeAmount}}
               </v-flex>
            </v-layout>
            <v-layout row class="detailfieldinfo" v-if="!!cover.price.technicalFeeVatAmount">
               <v-flex xs6>
                  <v-label >{{$t('Cover.ShowCover.TECHNICAL_FEES_VAT_AMOUNT_FIELD_NAME')}} ({{cover.price.technicalFeeVatRate}}) : </v-label>
               </v-flex>
               <v-flex xs6>
                   {{cover.price.technicalFeeVatAmount}}
               </v-flex>
            </v-layout>
             <v-layout row class="detailfieldinfo">
               <v-flex xs6>
                  <v-label ><span class="sub-title-header">{{$t('Cover.ShowCover.TOTAL_TECHNICAL_FEES_FIELD_NAME')}} : </span></v-label>
               </v-flex>
               <v-flex xs6 class="sub-title-header">
                   {{cover.price.totalTechnicalFee}}
               </v-flex>
            </v-layout>
        </div>
        <a name="pricedetails" id="pricedetails"></a>
    </div>

</template>
<script>
import { mapState } from 'vuex'
export default {
  mounted () {
    this.$nextTick(function () {
      var elpricedetails = document.getElementById('pricedetails')
      elpricedetails.scrollIntoView()
    })
  },
  computed: {
    ...mapState('cover', ['cover'])
  }
}
</script>
<style>
.pricedetailsfeesSession{
    padding-top: 20px
}
</style>
